export var isSafari = typeof navigator !== 'undefined' && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent);
//# sourceMappingURL=isSafari.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g-webgpu-core/es/utils/isSafari.js
// module id = null
// module chunks = 